import script from "./CreateEditMedicalAlerts.vue?vue&type=script&lang=ts&setup=true"
export * from "./CreateEditMedicalAlerts.vue?vue&type=script&lang=ts&setup=true"

import "./CreateEditMedicalAlerts.vue?vue&type=style&index=0&id=83f4d4ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-83f4d4ae"]])

export default __exports__